import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  component: AdminEmailPage,
});
